import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {AuthService} from "../service/auth.service";
import {Observable,} from "rxjs";
import {filter, switchMap} from 'rxjs/operators'
import {UserServiceService} from "../service/user-service.service";
import {LoginIdService} from "../service/login-id.service";
import {User} from "../model/user";
import * as Sentry from "@sentry/angular";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor( private userService: UserServiceService, private loginIdService: LoginIdService, private authService: AuthService,) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.isDoneLoading$.pipe(
        filter(isDone => isDone),
        switchMap(async () => {
          if (!this.authService.hasValidToken()) {
            this.authService.login(state.url);
          } else {
            await this.performAuthenticatedActions();
          }
          return this.authService.hasValidToken();
        })
    );
  }


  async performAuthenticatedActions() {
    console.log("Fetching performAuthenticatedActions")
    let user: User | null = this.getUserFromSessionStorage();
    if(!user){
      user = await this.userService.getUser().toPromise();
      sessionStorage.setItem("user", JSON.stringify(user));
    }

    Sentry.getCurrentScope().setTag('userId', user.id);
    Sentry.setUser({id: user.id});

    let currentMultiUser = this.getCurrentMultiUserFromSessionStorage();
    if(currentMultiUser){
      Sentry.getCurrentScope().setTag('currentMultiUserId', currentMultiUser.id);
    }

    //Set the user for the loginIdService
    this.loginIdService.setUpUser();
    this.loginIdService.updateLoginStatus(true);
  }

  /**
   * Tries to retrieve the current user from the session storage.
   * If no user can be found in the session storage null is returned
   *
   * @return The current user from the session storage if found else null
   */
  private getUserFromSessionStorage(): User | null{
    const userFromSessionStorage = sessionStorage.getItem("user");
    return userFromSessionStorage ? JSON.parse(userFromSessionStorage) : null;
  }

  /**
   * Tries to retrieve the current multiuser from the session storage.
   * If no current multiuser can be found in the session storage null is returned.
   *
   * @return The current multiuser from the session storage if found else null
   */
  private getCurrentMultiUserFromSessionStorage(): User | null{
    const currentMultiUserFromSessionStorage = sessionStorage.getItem("currentMultiUser");
    return currentMultiUserFromSessionStorage ? JSON.parse(currentMultiUserFromSessionStorage) : null;
  }

}
